import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function DialogCloseButton({ onClose, ...props }) {
  return (
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: theme => theme.palette.grey[500],
      }}
      {...props}>
      <CloseIcon />
    </IconButton>
  );
}

export default DialogCloseButton;
